export default __webpack_public_path__ + "static/media/bg4.8d38a978.png";